// Keep routing independent of page content and browser globals.
export const USE_CASE_SLUGS = [
  'software-delivery-invoice-evidence',
  'software-delivery-investment-review',
  'software-supplier-delivery-review',
  'scope-creep-project-margin',
  'engineering-capacity-planning',
  'outsourced-project-scope-and-spend',
];
export const USE_CASE_ROUTES = USE_CASE_SLUGS.map((slug) => `use-cases/${slug}`);
